var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkedWithoutBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60157 0.818237H1.39823C0.794364 0.818237 0.300293 1.31231 0.300293 1.91617V11.4957C0.300293 11.7564 0.451259 12.0035 0.684571 12.1133C0.931606 12.223 1.20609 12.1956 1.41195 12.0309L1.42568 12.0172L4.4999 9.42331L7.57412 12.0172L7.58784 12.0309C7.71136 12.127 7.86233 12.1819 8.01329 12.1819C8.10936 12.1819 8.21916 12.1544 8.31523 12.0995C8.54854 11.9897 8.6995 11.7427 8.6995 11.4819V1.91617C8.6995 1.31231 8.20543 0.818237 7.60157 0.818237Z",
    fill: "#FFB301"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkedWithoutBorder);
export default __webpack_public_path__ + "static/media/BookmarkedWithoutBorder.a78b7258.svg";
export { ForwardRef as ReactComponent };